import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cygov-license-framework-notice',
  templateUrl: './license-framework-notice.component.html',
  styleUrls: ['./license-framework-notice.component.scss'],
  standalone: false,
})
export class LicenseFrameworkNoticeComponent implements OnInit {
  @Input() licensedFrameworksCount: number = 0;
  @Input() frameworkName: string = '';
  @Output() modalResult = new EventEmitter<boolean>();

  confirmationString: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  setModalResult(result: boolean) {
    this.modalResult.emit(result);
    this.activeModal.close(result);
  }

  isConfirmDisabled(): boolean {
    return this.confirmationString.toLowerCase() !== 'confirm';
  }

  /**
   * Copy text to clipboard
   */
  copyToClipboard(text): void {
    navigator.clipboard
      .writeText(text)
      .then()
      .catch(e => console.error(e));
  }

  /**
   * Determines if this is a multiple frameworks scenario
   */
  get hasMultipleFrameworks(): boolean {
    return this.licensedFrameworksCount > 1;
  }
}
